import { Service } from '@/api/apiServices';
import { columns } from '@/components/services_tsx/columns';
import { ServiceDialog } from '@/components/services_tsx/service-dialog';
import { Button } from '@/components/ui/button';
import { DataTable } from '@/components/ui/data-table';
import { useServices } from '@/hooks/useServices';
import { Plus } from 'lucide-react';
import { useState } from 'react';

const Services = () => {
  // State for managing the service dialog
  const [open, setOpen] = useState(false);
  const [selectedService, setSelectedService] = useState<Service | undefined>(undefined);

  // Get services data and actions from our custom hook
  const { services, isLoading, error, deleteService, swapServicePosition } = useServices();

  // Dialog handlers
  const handleOpenDialog = (service?: Service | undefined) => {
    setSelectedService(service ?? undefined);
    setOpen(true);
  };

  const handleCloseDialog = () => {
    setSelectedService(undefined);
    setOpen(false);
  };

  // Error handling
  if (error) {
    return <div>Error loading services: {error.message}</div>;
  }

  return (
    <div className="flex flex-col px-1 py-2 sm:py-0">
      {/* Table Section */}
      <div className="flex-1 ">
        <div className="bg-white rounded-lg shadow-sm px-1 py-3 sm:p-4">
          {/* Header Section */}
          <div className="flex items-center justify-between pb-4">
            <h1 className="text-2xl font-bold tracking-tight">Services: {services?.length || 0}</h1>
            <Button onClick={() => handleOpenDialog()}>
              <Plus className="mr-2 h-4 w-4" />
              Add Service
            </Button>
          </div>
          <div className="">
            <DataTable
              columns={columns({
                onEdit: handleOpenDialog,
                onDelete: deleteService,
                onSwapPosition: (currentRow, targetRow, direction) =>
                  swapServicePosition({ currentRow, targetRow, direction }),
              })}
              data={services}
              searchKey="serTitle"
              isLoading={isLoading}
              compact
            />
          </div>
        </div>
      </div>

      {/* Dialog Section */}
      <ServiceDialog open={open} onClose={handleCloseDialog} service={selectedService} />
    </div>
  );
};

export default Services;
